import request from '../../../shared/request'

export function getLeadFollowUps(lead_id) {
  return request(`/lead/follow_ups/${lead_id}/`)
}

export function getLeadFollowUpActivities(follow_up_id) {
  return request(`/lead/activities/follow_up/${follow_up_id}/`)
}

export function createLeadFollowUp(payload) {
  return request(`/lead/follow_ups/${payload.lead_follow_up_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateLeadFollowUp(payload) {
  return request(`/lead/follow_ups/${payload.lead_follow_up_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteLeadFollowUp(payload) {
  return request(`/lead/follow_ups/${payload.lead_follow_up_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/lead/followUps.js